var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('VueShowdown',{staticClass:"markdown-tool",attrs:{"markdown":_vm.tool}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }